module.exports = __webpack_public_path__ + "static/media/quote2.db2782e2.png";